import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "landing_container" }
const _hoisted_2 = { class: "d-flex justify-content-between px-5 px-lg-10 bg-white align-items-center" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = ["alt"]
const _hoisted_5 = { class: "d-flex align-items-center w-100 w-lg-75 w-xl-50 w-lg-50 ps-3 ps-md-10 ps-lg-0 justify-content-between" }
const _hoisted_6 = { class: "ms-0 ms-md-10 ms-lg-20" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { tabindex: "0" }
const _hoisted_9 = { class: "first-section-landing position-relative mt-10" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "video_section skewed_container p-20 mt-15" }
const _hoisted_12 = { class: "text-center w-100 w-xl-50 mx-auto px-5 px-lg-20 mt-20" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "mt-20" }
const _hoisted_15 = { class: "mb-5 w-75 mx-auto" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "mt-20 pt-20 mx-10 mx-xl-20 px-0 px-xl-20" }
const _hoisted_18 = { class: "mx-xl-20 mt-0 mt-lg-20" }
const _hoisted_19 = { class: "text-dark-blue display-5 title-landing" }
const _hoisted_20 = { class: "row container-opportunities" }
const _hoisted_21 = ["index", "src"]
const _hoisted_22 = { class: "mx-sm-0 mx-md-10 fs-2 opportunity-content__container" }
const _hoisted_23 = { class: "text-dark-blue" }
const _hoisted_24 = { class: "text-gray-800" }
const _hoisted_25 = { class: "mx-10 mx-xl-20 px-0 px-xl-20 introduce-section fw-bold" }
const _hoisted_26 = { class: "mx-lg-20 mt-20" }
const _hoisted_27 = { class: "text-dark-blue display-5 title-landing" }
const _hoisted_28 = { class: "how-does-it-work-content row mt-20" }
const _hoisted_29 = { class: "col-md-4 col-sm-12 pe-10 pe-lg-20" }
const _hoisted_30 = { class: "mt-10 text-dark-blue fs-2" }
const _hoisted_31 = { class: "col-md-4 col-sm-12 pe-10 pe-lg-20" }
const _hoisted_32 = { class: "mt-10 text-dark-blue fs-2" }
const _hoisted_33 = { class: "col-md-4 col-sm-12 pe-10 pe-lg-20" }
const _hoisted_34 = { class: "mt-10 text-dark-blue fs-2" }
const _hoisted_35 = { class: "introduction_section" }
const _hoisted_36 = { class: "mx-10 mx-xl-20 px-0 px-xl-20" }
const _hoisted_37 = { class: "mx-lg-20" }
const _hoisted_38 = { class: "text-dark-blue display-5 title-landing" }
const _hoisted_39 = { class: "row mt-20 container-descriptions" }
const _hoisted_40 = { class: "col-lg-6 col-md-12" }
const _hoisted_41 = { class: "row iii-description" }
const _hoisted_42 = { class: "col-md-7 col-lg-12" }
const _hoisted_43 = { class: "mt-md-6 mt-lg-20 text-dark-blue" }
const _hoisted_44 = { class: "w-100 w-lg-75 text-gray-800 fs-2" }
const _hoisted_45 = { class: "col-lg-6 col-md-12" }
const _hoisted_46 = { class: "row plus-description" }
const _hoisted_47 = { class: "col-md-7 col-lg-12" }
const _hoisted_48 = { class: "mt-md-6 mt-lg-20 text-dark-blue" }
const _hoisted_49 = { class: "w-100 w-lg-75 text-gray-800 fs-2" }
const _hoisted_50 = { class: "plus_section skewed_container" }
const _hoisted_51 = { class: "text-white text-center container-go-to-survey" }
const _hoisted_52 = { class: "text-white display-4 header-survey-plus" }
const _hoisted_53 = { class: "fs-2 mt-10 w-100 w-md-50 mx-auto paragraph-survey-plus" }
const _hoisted_54 = {
  id: "container-footer-landing",
  class: "d-flex mx-10"
}
const _hoisted_55 = { id: "container-iii-plus-logo" }
const _hoisted_56 = ["alt"]
const _hoisted_57 = ["alt"]
const _hoisted_58 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_59 = { id: "container-valored-logo" }
const _hoisted_60 = { class: "d-flex flex-center flex-column-auto pt-5" }
const _hoisted_61 = { class: "d-flex align-items-center fw-bold fs-6" }
const _hoisted_62 = { class: "d-none d-md-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_language_switcher = _resolveComponent("language-switcher")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTFooter = _resolveComponent("KTFooter")!
  const _component_MobileFooter = _resolveComponent("MobileFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          id: "header-logo-landing",
          class: "h-lg-75px h-md-50px d-none d-md-block",
          src: "/media/logos/head_logo.png",
          alt: _ctx.translate('III_PLUS_LOGO')
        }, null, 8, _hoisted_3),
        _createElementVNode("img", {
          class: "h-25px d-block d-md-none",
          src: "/media/logos/logo.png",
          alt: _ctx.translate('III_PLUS_COMPACTED_LOGO')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/sign-in",
            class: "btn-go-to-sign-in btn btn-md btn-dark-blue px-5 px-lg-15"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.translate("DASHBOARD_SURVEY_BUTTON")) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-arrow-right ms-5" }, null, -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_language_switcher)
          ]),
          _createVNode(_component_inline_svg, {
            class: "h-20px h-lg-50px h-md-25px ms-3 ms-md-10",
            src: "/media/vectorial/valored_logo.svg",
            alt: _ctx.translate('VALORED_PROJECT_LOGO'),
            lang: "it",
            title: _ctx.translate('VALORED_PROJECT_LOGO'),
            "aria-label": _ctx.translate('VALORED_PROJECT_LOGO')
          }, null, 8, ["alt", "title", "aria-label"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: "landing_title ms-13 pt-0 pt-md-20 text-dark-blue",
        innerHTML: _ctx.translate('LANDING_HOW_MUCH_INCLUSIVE')
      }, null, 8, _hoisted_10),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "first-section-image" }, [
        _createElementVNode("img", {
          class: "background_1 d-none d-md-block",
          src: "/media/valored/landing_bg1.png",
          alt: ""
        })
      ], -1))
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-center mobile-pc__image" }, [
      _createElementVNode("img", {
        class: "w-100",
        src: "/media/landing/mobile-pc.png",
        alt: ""
      })
    ], -1)),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", {
          class: "text-white display-6",
          innerHTML: _ctx.translate('LANDING_DISCOVER_III'),
          style: {"font-weight":"400"}
        }, null, 8, _hoisted_13)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        class: "background-2 ms-20",
        src: "/media/shape/pink-landing.svg",
        alt: ""
      }, null, -1)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("iframe", {
            class: "embed-responsive-item rounded h-550px w-100 landing-video",
            src: "https://player.vimeo.com/video/766813949?h=997b2ffe90&badge=0&autopause=0&player_id=0&app_id=58479&dnt=1",
            allowfullscreen: "",
            title: _ctx.translate('LANDING_VIDEO')
          }, null, 8, _hoisted_16)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title-landing-decoration" }, null, -1)),
        _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.translate("LANDING_MORE_OPPORTUNITIES")), 1),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opportunities, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-sm-12 col-md-6 d-sm-block d-md-flex pe-0 pe-lg-20 mt-20 opportunity-item"
            }, [
              _createElementVNode("img", {
                class: "opportunities-icon",
                index: index,
                src: item.image,
                alt: ""
              }, null, 8, _hoisted_21),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.translate(item.title)), 1),
                _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.translate(item.content)), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"chat_section skewed_container px-30 d-flex justify-content-around\"><div class=\"left-section skewed__section\"><img class=\"position-absolute image-governance\" src=\"/media/landing/Governance.png\" alt=\"\"></div><div class=\"right-section skewed__section\"><img class=\"position-absolute image-ampiezza\" src=\"/media/landing/Ampiezza.png\" alt=\"\"></div></div>", 1)),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title-landing-decoration" }, null, -1)),
        _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.translate("LANDING_HOW_IT_WORKS")), 1),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[4] || (_cache[4] = _createElementVNode("img", {
              src: "/media/landing/feature_1.png",
              alt: "1"
            }, null, -1)),
            _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.translate("LANDING_HOW_IT_WORKS_REGISTER")), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[5] || (_cache[5] = _createElementVNode("img", {
              src: "/media/landing/feature_2.png",
              alt: "2"
            }, null, -1)),
            _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.translate("LANDING_HOW_IT_WORKS_FILL_IN_INFO")), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _cache[6] || (_cache[6] = _createElementVNode("img", {
              src: "/media/landing/feature_3.png",
              alt: "3"
            }, null, -1)),
            _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.translate("LANDING_HOW_IT_WORKS_COMPARE")), 1)
          ])
        ])
      ])
    ]),
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "gradient_section" }, null, -1)),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title-landing-decoration" }, null, -1)),
          _createElementVNode("h2", _hoisted_38, _toDisplayString(_ctx.translate("LANDING_EVEN_MORE_POWERFUL")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.translate("LANDING_EVEN_MORE_POWERFUL_DETAIL")), 1),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-5 col-lg-12" }, [
                  _createElementVNode("img", {
                    src: "/media/valored/survey-iii.png",
                    class: "w-75 w-lg-50 left-introduction__image mb-10",
                    alt: "Inclusion Impact Index"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.translate(
                        "LANDING_EVEN_MORE_POWERFUL_QUANTITATIVE_REPORT"
                      )), 1),
                  _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.translate(
                        "LANDING_EVEN_MORE_POWERFUL_QUANTITATIVE_REPORT_DETAIL"
                      )), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-md-5 col-lg-12" }, [
                  _createElementVNode("img", {
                    src: "/media/valored/survey-plus.png",
                    class: "w-75 w-lg-50 right-introduction__image mb-10",
                    alt: "Inclusion Plus"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("h3", _hoisted_48, _toDisplayString(_ctx.translate("LANDING_EVEN_MORE_POWERFUL_QUALITATIVE_REPORT")), 1),
                  _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.translate(
                        "LANDING_EVEN_MORE_POWERFUL_QUALITATIVE_REPORT_DETAIL"
                      )), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_50, [
      _cache[11] || (_cache[11] = _createElementVNode("img", {
        src: "/media/landing/plus.png",
        alt: "",
        class: "plus_image"
      }, null, -1)),
      _cache[12] || (_cache[12] = _createElementVNode("img", {
        class: "w-100 d-block d-md-none",
        src: "/media/landing/mobile-pc.png",
        alt: ""
      }, null, -1)),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("h2", _hoisted_52, _toDisplayString(_ctx.translate("LANDING_III_PLUS")), 1),
        _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.translate("LANDING_III_PLUS_DETAIL")), 1),
        _createVNode(_component_router_link, {
          to: "/sign-in",
          class: "btn-go-to-sign-in btn btn-white text-dark-blue mt-5 mt-md-20 mb-5 mb-md-20"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.translate("DASHBOARD_SURVEY_BUTTON")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("img", {
          id: "iii-plus-logo-extended",
          src: "/media/logos/head_logo.png",
          alt: _ctx.translate('III_PLUS_LOGO'),
          style: {"width":"400px"}
        }, null, 8, _hoisted_56),
        _createElementVNode("img", {
          id: "iii-plus-logo-compacted",
          src: "/media/logos/logo_valored_compact.png",
          alt: _ctx.translate('III_PLUS_COMPACTED_LOGO'),
          style: {"height":"127px"}
        }, null, 8, _hoisted_57)
      ]),
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createVNode(_component_inline_svg, {
            id: "valored-logo",
            class: "h-20px h-lg-50px h-md-25px",
            src: "/media/vectorial/valored_logo.svg",
            style: {"height":"78px !important"},
            alt: _ctx.translate('VALORED_PROJECT_LOGO'),
            lang: "it",
            title: _ctx.translate('VALORED_PROJECT_LOGO'),
            "aria-label": _ctx.translate('VALORED_PROJECT_LOGO')
          }, null, 8, ["alt", "title", "aria-label"]),
          _cache[13] || (_cache[13] = _createElementVNode("span", { style: {"font-size":"14px"} }, [
            _createTextVNode(" Vai al sito di "),
            _createElementVNode("a", {
              href: "https://valored.it/",
              target: "_blank",
              class: "footer-link"
            }, " Valore D ")
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createVNode(_component_KTFooter)
        ]),
        _createVNode(_component_MobileFooter)
      ])
    ])
  ]))
}